import photoGalleryApi from "../api/photo-gallery-api";

const generateLinkPhotoGalleryById = async (payload) => {
    const resp = await photoGalleryApi.generateLinkPhotoGalleryById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const moveFile = async (payload) => {
    const resp = await photoGalleryApi.moveFile(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const createFolder = async (payload) => {
    const resp = await photoGalleryApi.createFolder(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await photoGalleryApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await photoGalleryApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await photoGalleryApi.search(condition, pagination);
        // console.log(result);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const add = async (photoGallery) => {
    const resp = await photoGalleryApi.add(photoGallery);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const photoGalleryService = {
    generateLinkPhotoGalleryById,
    moveFile,
    createFolder,
    edit,
    search,
    remove,
    add
};

export default photoGalleryService;
